export const cancelFlowConstants = {
    SET_APPOINTMENT_BOOKED: "SET_APPOINTMENT_BOOKED",
    CLEAR_APPOINTMENT_BOOKED: "CLEAR_APPOINTMENT_BOOKED",
    RESET_CANCEL_FLOW: "RESET_CANCEL_FLOW",
}
